export const fullOrientation = (input: string) => {
  if (input === "s") return "South";
  if (input === "w") return "West";
  if (input === "e") return "East";
  if (input === "n") return "North";
  if (input === "se") return "SouthEast";
  if (input === "sw") return "SouthWest";
  if (input === "nw") return "NorthWest";
  if (input === "ne") return "NorthEast";
  return input;
};
